import React from 'react'
import './filters.css'


const Filters = ({genreList, handleGenreFilter, handleOrderByAlphabet, handleOrderByRating, handleOriginFilter}) => {



  return (
    <>
      <div className="filter-div">
                <select className="select-filter"  onChange={handleOrderByAlphabet}>
                    <option value="" disabled selected>Alfabetico</option>
                    <option value='none'> Normal </option>
                    <option value="ascA">A-Z</option>
                    <option value="descA">Z-A</option>
                </select>
 
                <select className="select-filter"  onChange={handleOrderByRating}>
                    <option value="" disabled selected>Rating</option>
                    <option value='none'> Normal </option>
                    <option value="ascR">Higher Rating</option>
                    <option value="descR">Lower Rating</option>
                </select>

                <select className="select-filter" onChange={handleGenreFilter}>
                    <option value="" disabled selected>Generos</option>
                    <option value="allGenres">Todos los géneros</option>
                    {genreList.map(genre => (
                        <option key={genre} value={genre}>{genre}</option>
                    ))}
                </select>

                <select className="select-filter" onChange={handleOriginFilter}>
                    <option value="" disabled selected>Origen</option>
                    <option value="allOrigin">Todos los orígenes</option>
                    <option value="API">API</option>
                    <option value="Database">Base de datos</option>
                </select>
            </div>
    </>
  )
}

export default Filters